import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchDoctors } from './api';

/** Tenant-wide — see queryKeys.ts's staff.byRole comment. */
export function useDoctors() {
  return useQuery({
    queryKey: keys.staff.byRole('Doctor'),
    queryFn: fetchDoctors,
    // The doctor roster changes on the order of "someone joined/left the
    // hospital" — a long staleTime avoids re-fetching it every time this
    // screen (or a future one) mounts within a session.
    staleTime: 10 * 60_000,
  });
}
